import { useCallback } from 'react';
import { startOfDay } from 'date-fns';

import { routeReplacer } from '~/Helpers/String.helper';
import { Route } from '~/Constants/Routes.constants';
import { EventType } from '~/Models/DTO/Event.model';
import { useDefaultTimeSeries } from '~/Screens/Events/EventCreate/EventCreateSections/EventScheduleSection/EventScheduleTimeSeries/useDefaultTimeSeries';
import { useDateFns, useNavigation } from '~/Hooks';
import { ICalendarEvent } from '~/Screens/Calendar/interfaces';

export const useShowAdvancedViewClick = (rowData: ICalendarEvent) => {
  const { getDefaultTimeSeries } = useDefaultTimeSeries();
  const { convertToProviderTimezone } = useDateFns();
  const { navigate } = useNavigation();

  const onShowAdvancedViewClick = useCallback(() => {
    const { end, start, ...event } = rowData;
    const dailyStartTime = convertToProviderTimezone(start);
    const dailyEndTime = convertToProviderTimezone(end);
    const timeSeries = getDefaultTimeSeries({
      eventType: event.type,
      startDate: startOfDay(new Date(dailyStartTime)).toISOString(),
    });
    const eventGroup = {
      ...event,
      timeSeries: [{ ...timeSeries, dailyStartTime, dailyEndTime }],
    };
    navigate(
      routeReplacer(Route.EVENT_TYPE_CREATE, { eventType: event.type as EventType }),
      undefined,
      {
        eventGroup,
      },
    );
  }, [rowData, getDefaultTimeSeries, navigate]);

  return { onShowAdvancedViewClick };
};
